<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">

          <strong>Deletar E-Mail da Lista de Bloqueio</strong>
        </div>
        <b-row>
          <b-col style="padding-top: 15px">
            <b-alert show variant="info">
              <p class="font-weight-bold mb-0">
                <!-- Explicação sobre como funciona o delete na lista de supressão -->
                Esta página permite a remoção de endereços de e-mail da lista de bloqueios 
              </p>
            </b-alert>

          </b-col>
        </b-row>
        <b-form @submit.stop.prevent>
          <b-form-group label="Região AWS" label-for="aws-region">
            <b-form-select v-model="model.awsRegion" id="aws-region">
              <option value="us-east-1">us-east-1</option>
              <option value="sa-east-1">sa-east-1</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="E-Mail" label-for="cpf-cnpj">
            <b-form-input v-model="model.email" id="email" placeholder="admin@teste.com" type="email"></b-form-input>
          </b-form-group>
          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="danger" @click="deleteEmail">
                  <i class="fa fa-trash"></i> Deletar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>

      </b-card>
      <b-modal id="modal-email-loggs" ref="modalEmailLogger" title="Detalhes">
        <b-row>
          <b-col style="padding-top: 15px">
            <b-alert show variant="success" v-if="dataResponse.status == 'success'">
              <p class="font-weight-bold mb-0">E-mail excluído com sucesso</p>
            </b-alert>
            <b-alert show variant="danger" v-else>
              <p class="font-weight-bold mb-0">E-mail não excluído</p>
              <p>{{ msgErr }}</p>

            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="font-weight-bold mb-0">Resposta</p>
            <pre class="bg-code p-3">{{ dataResponse }}</pre>
          </b-col>
        </b-row>
      </b-modal>


      <b-modal id="modal-email-info" ref="modalEmailInfo" title="Informações">
        <div>
          <!-- Using modifiers -->
          <b-button v-b-toggle.collapse-2 class="m-1">Mensagem de Sucesso</b-button>

          <!-- Using value -->
          <b-button v-b-toggle="'collapse-2'" class="m-1">Toggle Collapse</b-button>

          <!-- Element to collapse -->
          <b-collapse id="collapse-success">
            <b-card>I am collapsible content!</b-card>
          </b-collapse>
          <b-collapse id="collapse-error">
            <b-card>I am collapsible content!</b-card>
          </b-collapse>
        </div>

      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      clientId: null,
      loadCount: 0,
      modelQuery: {
        awsRegion: 'us-east-1',
        email: ''
      },
      model: {
        email: '',
        awsRegion: 'us-east-1',
      },
      dataResponse: '',
      msgErr: 'O endereço de e-mail fornecido pode não estar atualmente na lista de bloqueios'

    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  mounted() {

  },
  methods: {
    clean() {
      const self = this;
      self.clientId = '';
    },


    deleteEmail() {
      var self = this;
      this.loadCount++;
      if (self.model.email == null || self.model.email == '') {
        self.$bvModal.msgBoxOk('Informe o E-Mail!')
          .then(value => {
            console.log(value);
          })
          .catch(console.error);
        self.loadCount--;
        return;
      }
      axios
        // .delete(`${env.urlBillingApi}/mail-supression-list/1`, { params: self.modelQuery })
        .post(`${env.urlBillingApi}/mail-supression-list`, self.model)
        .then(function (response) {
          self.dataResponse = response.data;

        })
        .catch(function (error) {
          self.msgErr = 'Erro ao excluir o e-mail da lista de bloqueio';
          if (error.response) {
            self.msgErr = 'O endereço de e-mail fornecido pode não estar atualmente na lista de bloqueios'
            self.dataResponse = error.response;
            if (error.response.data) {
              self.dataResponse = error.response.data;
              if (error.response.data.detail) {
                self.dataResponse = error.response.data.detail;
                if(error.response.data.detail.messages){
                  if(Array.isArray(error.response.data.detail.messages)){
                    let msg = error.response.data.detail.messages[0];
                    if(msg.status == 'notFound'){
                      self.msgErr = 'Não encontrado na lista de bloqueio'
                    }
                  }
                }
              } 
            }
          } else {
            self.dataResponse = error;
          }
        })
        .finally(() => {
          self.$refs.modalEmailLogger.show();
          self.loadCount--;
        });
    }
  }
}
</script>
